import React from "react";
import "./App.css";

function Man() {
  return (
    <>
      <div className="life1"></div>
      <div className="life2"></div>
      <div className="life3"></div>
      <div className="life4"></div>
      <div className="life5"></div>
      <div className="life6"></div>
      <div className="hanger"></div>
    </>
  );
}
export default Man;
